import React from 'react';
import { Alert, Text, TextProps } from '@chakra-ui/react';

type LDTransactionMessageProps = {
  title: string;
  textProps: TextProps;
} & React.ComponentProps<typeof Alert.Root>;

const LDTransactionMessage: React.FC<LDTransactionMessageProps> = ({
  title,
  textProps,
  ...props
}: LDTransactionMessageProps) => {
  return (
    <Alert.Root {...props}>
      <Text {...textProps} w="100%" textAlign="center">
        {title}
      </Text>
    </Alert.Root>
  );
};
export default LDTransactionMessage;
